import deepEqual from 'fast-deep-equal'
import * as R from 'ramda'
import { PhoneUtils } from '@pbt/pbt-ui-components'

import type { Contact } from '~/types'

/**
 * Snapshot of only fields edited in Contact.tsx. Redux Contact may include
 * nameTranslation, SMS fields, etc. — comparing full objects to get() always
 * looked "dirty" after save.
 */
export type ContactFormSnapshot = {
  address: string
  city: string
  country: Contact['country']
  email: string
  id: string | undefined
  inReferralList: boolean
  name: string
  notes: string
  phone: string
  state: string
  suite: string
  type: string | null
  website: string
  zip: string
}

function normalizeNotes(n: string | undefined | null): string {
  return n ?? ''
}

export function snapshotFromReduxContact(c: Contact): ContactFormSnapshot {
  return {
    address: c.address ?? '',
    city: c.city ?? '',
    country: c.country,
    email: c.email ?? '',
    id: c.id,
    inReferralList: Boolean(c.inReferralList),
    name: c.name ?? '',
    notes: normalizeNotes(c.notes),
    phone: PhoneUtils.parsePhoneNumber(c.phone ?? ''),
    state: c.state ?? '',
    suite: c.suite ?? '',
    type: c.type ?? null,
    website: c.website ?? '',
    zip: c.zip ?? '',
  }
}

export function snapshotFromFormGet(
  g: Partial<ContactFormSnapshot> & { phone?: string | null },
): ContactFormSnapshot {
  return {
    address: g.address ?? '',
    city: g.city ?? '',
    country: g.country as Contact['country'],
    email: g.email ?? '',
    id: g.id,
    inReferralList: Boolean(g.inReferralList),
    name: g.name ?? '',
    notes: normalizeNotes(g.notes),
    phone: PhoneUtils.parsePhoneNumber(String(g.phone ?? '')),
    state: g.state ?? '',
    suite: g.suite ?? '',
    type: g.type ?? null,
    website: g.website ?? '',
    zip: g.zip ?? '',
  }
}

export function isContactFormDirty(
  store: Contact | undefined,
  formGet: Partial<ContactFormSnapshot> | null | undefined,
): boolean {
  if (!store || R.isEmpty(store) || !formGet) {
    return false
  }
  return !deepEqual(
    snapshotFromReduxContact(store),
    snapshotFromFormGet(formGet),
  )
}
